const MONTH_ABBR = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC'
] as const;

type DateParts = {
  year: number;
  month: number;
  day: number;
};

const parseIsoDateParts = (value: string): DateParts | null => {
  const match = value.slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3])
  };
};

export const toDateRangeLabel = (
  fromDate: string,
  toDate: string
): string | null => {
  const from = parseIsoDateParts(fromDate);
  const to = parseIsoDateParts(toDate);
  if (!from || !to) return null;

  const fromDay = String(from.day).padStart(2, '0');
  const toDay = String(to.day).padStart(2, '0');
  const fromMonth = MONTH_ABBR[from.month - 1];
  const toMonth = MONTH_ABBR[to.month - 1];

  if (!fromMonth || !toMonth) return null;

  if (from.year === to.year && from.month === to.month) {
    return `${fromDay}-${toDay} ${fromMonth} ${from.year}`;
  }

  if (from.year === to.year) {
    return `${fromDay} ${fromMonth}-${toDay} ${toMonth} ${from.year}`;
  }

  return `${fromDay} ${fromMonth} ${from.year}-${toDay} ${toMonth} ${to.year}`;
};

type BuildHistoricalDownloadFileNameArgs = {
  symbol: string;
  timeframe: string;
  fromDate?: string;
  toDate?: string;
};

export const buildHistoricalDownloadFileName = ({
  symbol,
  timeframe,
  fromDate,
  toDate
}: BuildHistoricalDownloadFileNameArgs): string => {
  const rangeLabel =
    fromDate && toDate ? toDateRangeLabel(fromDate, toDate) : null;
  const rangeSuffix = rangeLabel ? ` (${rangeLabel})` : '';

  return `${symbol}_${timeframe}${rangeSuffix}.csv`;
};
